import validate from "D:/.jenkins/workspace/web-prod-xkira-official-website/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@_0a82593bfa7fb480d583bd8758123f00/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/.jenkins/workspace/web-prod-xkira-official-website/node_modules/.pnpm/nuxt@3.17.5_@netlify+blobs@_0a82593bfa7fb480d583bd8758123f00/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}